<app-navbar></app-navbar>

<div class="container mt-4">

  <!-- STEP 1: SELEZIONE PAZIENTE (solo se non c'è ancora un accesso creato) -->

  <div *ngIf="!currentAccesso" class="card-custom shadow-sm mb-4">

    <div class="card-body">

      <h4 class="mb-4">
        <i class="fa-solid fa-user"></i>
        Step 1: Seleziona Paziente
      </h4>

      <!-- RICERCA PAZIENTE -->

      <div class="row g-3 align-items-end mb-3">

        <div class="col-md-8">

          <label class="form-label">
            <i class="fa-solid fa-magnifying-glass me-1"></i>
            Ricerca paziente esistente
          </label>

          <div class="input-group">

            <input
              type="text"
              class="form-control"
              placeholder="Cerca per nome, cognome o codice..."
              [(ngModel)]="searchTerm"
              (keyup.enter)="onSearch()">

            <button
              class="btn btn-dark-senior"
              (click)="onSearch()"
              [disabled]="searching">
              <span *ngIf="searching" class="spinner-border spinner-border-sm me-1" role="status"></span>
              <i class="fa-solid fa-search"></i>
              Cerca
            </button>

          </div>

        </div>

      </div>

      <!-- RISULTATI RICERCA -->

      <div *ngIf="searchResults.length > 0" class="mb-3">

        <strong class="d-block mb-2">
          <i class="fa-solid fa-list me-1"></i>
          Risultati trovati ({{ searchResults.length }}):
        </strong>

        <div class="table-responsive">

          <table class="table table-hover table-sm">

            <thead>
              <tr>
                <th>Codice</th>
                <th>Cognome</th>
                <th>Nome</th>
                <th>Genere</th>
                <th>Data nascita</th>
                <th>Azioni</th>
              </tr>
            </thead>

            <tbody>

              <tr *ngFor="let patient of searchResults">

                <td>
                  <span class="badge bg-secondary">
                    {{ patient.codice }}
                  </span>
                </td>

                <td>{{ patient.cognome }}</td>
                <td>{{ patient.nome }}</td>
                <td>
                  <i class="fa-solid fs-5"
                    [class.fa-mars]="patient.genere === 'M'"
                    [class.fa-venus]="patient.genere === 'F'"
                    [class.gender-male]="patient.genere === 'M'"
                    [class.gender-female]="patient.genere === 'F'">
                  </i>
                </td>
                <td>{{ patient.dataNascita | date:'dd/MM/yyyy' }}</td>
                <td>
                  <button
                    class="btn btn-sm btn-teal-custom"
                    (click)="selectPatient(patient)">
                    <i class="fa-solid fa-check"></i>
                    Seleziona
                  </button>
                </td>

              </tr>

            </tbody>

          </table>

        </div>

      </div>

      <!-- ERRORE RICERCA / NESSUN RISULTATO -->

      <div *ngIf="searchError && searchResults.length === 0 && !searching" class="alert alert-info mb-3">
        <i class="fa-solid fa-info-circle me-1"></i>
        {{ searchError }}
      </div>

      <!-- DIVISORE / OPPURE -->

      <div class="d-flex align-items-center gap-3 my-3" *ngIf="searchResults.length === 0 && !searchError && !searching">

        <hr class="flex-grow-1">

        <span class="text-muted fw-medium">
          <i class="fa-solid fa-arrow-down me-1"></i>
          oppure
          <i class="fa-solid fa-arrow-down ms-1"></i>
        </span>

        <hr class="flex-grow-1">

      </div>

      <!-- PULSANTE CREA NUOVO PAZIENTE -->

      <div class="text-center" *ngIf="!searching">

        <button
          class="btn btn-outline-primary-custom"
          (click)="toggleNewPatientForm()">
          <i class="fa-solid fa-user-plus"></i>
          {{ showNewPatientForm ? 'Nascondi' : 'Crea un nuovo paziente' }}
        </button>

      </div>

      <!-- FORM CREAZIONE NUOVO PAZIENTE (opzionale) -->

      <div *ngIf="showNewPatientForm" class="mt-4">

        <app-patient-create [selectionMode]="true" (patientSelected)="onPatientSelected($event)">
        </app-patient-create>

      </div>

    </div>

  </div>

  <!-- DATI PAZIENTE SELEZIONATO -->

  <div *ngIf="selectedPatient && !currentAccesso" class="card-custom shadow-sm mb-4">

    <div class="card-body">

      <h4 class="mb-4">

        <i class="fa-solid fa-user-check text-success"></i>

        Paziente selezionato

        <span class="badge bg-success ms-2">
          {{ selectedPatient.codice }}
        </span>

      </h4>

      <div class="row">

        <div class="col-md-3 mb-3">

          <strong>Nome</strong>

          <div>
            {{ selectedPatient.nome }}
          </div>

        </div>

        <div class="col-md-3 mb-3">

          <strong>Cognome</strong>

          <div>
            {{ selectedPatient.cognome }}
          </div>

        </div>

        <div class="col-md-3 mb-3">

          <strong>Genere</strong>

          <div>
            {{ selectedPatient.genere }}
          </div>

        </div>

        <div class="col-md-3 mb-3">

          <strong>Data nascita</strong>

          <div>
            {{ selectedPatient.dataNascita | date:'dd/MM/yyyy' }}
          </div>

        </div>

      </div>

    </div>

  </div>

  <!-- HEADER ACCESSO (dopo creazione) -->

  <div *ngIf="currentAccesso" class="card-custom shadow-sm mb-4">

    <div class="card-body">

      <h4 class="mb-3">

        <i class="fa-solid fa-notes-medical"></i>

        Nuovo Accesso n. {{ currentAccesso.idAccesso }}

      </h4>

      <div class="row">

        <div class="col-md-4 mb-3">

          <strong>Data Accesso</strong>

          <div>
            {{ currentAccesso.dataAccesso | date:'dd/MM/yyyy HH:mm' }}
          </div>

        </div>

        <div class="col-md-4 mb-3">

          <strong>Tipo Accesso</strong>

          <div>

            <span
              class="badge"
              [ngClass]="{
                'bg-primo-accesso': currentAccesso.tipoAccesso === 'Primo Accesso',
                'bg-follow-up': currentAccesso.tipoAccesso === 'Follow Up'
              }">

              <i class="fa-solid" [ngClass]="{
                'fa-universal-access': currentAccesso.tipoAccesso === 'Primo Accesso',
                'fa-rotate': currentAccesso.tipoAccesso === 'Follow Up'
              }" *ngIf="currentAccesso.tipoAccesso === 'Primo Accesso' || currentAccesso.tipoAccesso === 'Follow Up'"></i>
              {{ currentAccesso.tipoAccesso }}

            </span>

          </div>

        </div>

      </div>

      <!-- RIEPILOGO PAZIENTE -->

      <div *ngIf="selectedPatient" class="mt-3 p-3 bg-light rounded">

        <strong>Paziente:</strong>

        {{ selectedPatient.nome }} {{ selectedPatient.cognome }}

        <span class="badge bg-secondary ms-2">
          {{ selectedPatient.codice }}
        </span>

      </div>

    </div>

  </div>

  <!-- LOADING -->

  <div *ngIf="loading" class="alert alert-info mt-3">

    Creazione accesso in corso...

  </div>

  <!-- ERROR -->

  <div *ngIf="error" class="alert alert-danger mt-3">

    {{ error }}

  </div>

  <!-- DATI ACCESSO (step 2) -->

  <div *ngIf="currentAccesso" class="card-custom shadow-sm mt-4">

    <div class="card-body">

      <h5 class="mb-4">

        <i class="fa-solid fa-pen-to-square"></i>

        Step 2: Dati Accesso

      </h5>

      <!-- CELLULARE -->

      <div class="mb-3">

        <label class="form-label">
          Cellulare
        </label>

        <input type="text" class="form-control" [(ngModel)]="cellulare">

      </div>

      <!-- MEDICO -->

      <div class="mb-3">

        <label class="form-label">
          Medico
        </label>

        <input type="text" class="form-control" [(ngModel)]="medico">

      </div>

      <!-- CELLULARE MEDICO -->

      <div class="mb-3">

        <label class="form-label">
          Cellulare del Medico
        </label>

        <input type="text" class="form-control" [(ngModel)]="medicoCellulare">

      </div>

      <!-- EMAIL MEDICO -->

      <div class="mb-3">

        <label class="form-label">
          Email del Medico
        </label>

        <input type="email" class="form-control" [(ngModel)]="medicoEmail">

      </div>

      <!-- BUTTON -->

      <button class="btn btn-teal-custom" (click)="saveAccesso()">

        <i class="fa-solid fa-floppy-disk"></i>

        Salva Accesso

      </button>

      <!-- SUCCESS -->

      <div *ngIf="success" class="alert alert-success mt-3">

        {{ success }}

      </div>

      <!-- ERROR -->

      <div *ngIf="error" class="alert alert-danger mt-3">

        {{ error }}

      </div>

    </div>

  </div>

  <!-- MODAL IMPORT CONTATTI -->

  <div *ngIf="showImportContattiModal" class="modal fade show d-block" tabindex="-1"
    style="background: rgba(0,0,0,0.4);">

    <div class="modal-dialog modal-dialog-centered">

      <div class="modal-content">

        <div class="modal-header">

          <h5 class="modal-title">

            <i class="fa-solid fa-address-book"></i>

            Precaricare contatti

          </h5>

        </div>

        <div class="modal-body">

          <p>

            È stato trovato un accesso precedente
            per questo paziente.

          </p>

          <p class="mb-0">

            Vuoi precaricare i dati di contatto
            dell'ultimo accesso?

          </p>

        </div>

        <div class="modal-footer">

          <button class="btn btn-outline-secondary" (click)="closeImportModal()">

            No

          </button>

          <button class="btn btn-teal-custom" (click)="importPreviousContatti()">

            <i class="fa-solid fa-copy"></i>

            Sì, precarica

          </button>

        </div>

      </div>

    </div>

  </div>

</div>